export default __webpack_public_path__ + "static/media/dk1.d3264143.jpg";